<body class="front">
  <div class="wrapper">
    <div class="container-fluid">
      <div class="row">
        <!-- <div class="col-sm-2 col-md-2 sidebar_wrapper">
          <div class="sidebar-podcast navbar-collapse collapse" id="myNavbar" aria-expanded="false">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#myNavbar"
              aria-expanded="false">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <div class="menu-box-podcast">
              <nav class="navbar navbar-inverse">
                <div>
                  <ul class="login-signup-box d-lg-none">
                    <li><a class="btn-signUp" href="#">Sign up</a></li>
                    <li><a class="btn-login" href="#">Log in</a></li>
                  <ul class="nav nav-sidebar-podcast bar01">
                    <li><a href="#"><i class="fa fa-home" aria-hidden="true"></i> Home</a></li>
                    <li><a href="#"><i class="fa fa-search" aria-hidden="true"></i> Search</a></li>
                    <li><a href="#"><i class="fa fa-book" aria-hidden="true"></i> Your Library</a></li>
                  </ul>
                  <ul class="nav nav-sidebar-podcast bar02">
                    <li><a href=""><i class="fa fa-plus-square" aria-hidden="true"></i> Create Playlist</a></li>
                    <li><a href=""><i class="fa fa-gratipay" aria-hidden="true"></i> Liked Songs</a></li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div> -->
        <div class="top_bar">
          <app-topbar>
        
          </app-topbar>

        </div>
        <div class="col-sm-12  col-md-12  main-podcast">
          <router-outlet></router-outlet>
          <div id="audio-player" class="music-player-1" *ngIf="objectKeys(audioList).length > 0">
          <app-music-player [audioData]="audioList"></app-music-player>
          </div>
          <!-- <div id="audio-player" class="music-player" *ngIf="audioList.length > 0">
            <ang-music-player  backgroundColor="#fff" (seekEvent)="seekEvent($event)" width="100%" [audioList]=audioList></ang-music-player>
          </div> -->
          
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>